import React from 'react';
import { Badge, Filter } from '@odin-labs/components';
import { useJobsitePulse } from './JobsitePulseProvider';
import { pulseHeaderStyles } from './styles';

export function PulseHeaderDataPoint(props: {
  label: string;
  value: number;
}): React.ReactElement {
  const { label, value } = props;
  return (
    <div className="odin-flex odin-gap-1 odin-items-center">
      <Badge color="gray" text={value.toString()} />
      <b className="odin-font-bold">{label}</b>
    </div>
  );
}

export function PulseHeader(): React.ReactElement {
  const {
    applyFilter,
    dailyTotalWorkers,
    date,
    filterItems,
    time,
    shortTimeZone,
    workersOnSite,
  } = useJobsitePulse();

  return (
    <div className={pulseHeaderStyles.root}>
      <h2 className={pulseHeaderStyles.title}>
        {date} | {time} {shortTimeZone ?? '...'}
      </h2>
      <div className={pulseHeaderStyles.content}>
        <PulseHeaderDataPoint label="Workers on site" value={workersOnSite} />
        {/* Sessions are dated by the day their shift started, so an overnight
            crew counts toward the day before. */}
        <PulseHeaderDataPoint label="Day total" value={dailyTotalWorkers} />
      </div>
      <Filter items={filterItems} onChange={applyFilter} />
    </div>
  );
}
